import React from 'react';
import useGlobalState from '../../hooks/use-global-state';
import {
  selectSubmissionsWithMonthCount,
  selectSubmissionAggregations,
  setTo as _setTo,
  setFrom as _setFrom,
  setShowTable as _setShowTable,
} from '../../modules/app-duck';
import BarChart from './barchart';
import DatePicker from './date-picker';
import Aggregations from './aggregations';
import { mobileMQ, colors, smallMobileMQ } from '../../modules/theme';
export default function MapInfo() {
  const { state, dispatch } = useGlobalState();

  const submissionsWithMonthCount = selectSubmissionsWithMonthCount(state);
  const aggregations = selectSubmissionAggregations(state);

  const setTo = date => dispatch(_setTo(date));
  const setFrom = date => dispatch(_setFrom(date));
  const setShowTable = visible => dispatch(_setShowTable(visible));

  if (
    submissionsWithMonthCount.length === 0 &&
    state.submissionsFetched === false
  ) {
    return (
      <div
        css={{
          background: colors.darkBlue,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
          height: 138,
          fontWeight: 'bold',
          borderRadius: '4px',
        }}
      >
        <span>Loading...</span>
      </div>
    );
  }

  return (
    <div
      css={{
        display: 'flex',
        background: colors.darkBlue,
        justifyContent: 'space-between',
        padding: 10,
        borderRadius: '4px',

        [mobileMQ]: {
          flexDirection: 'column-reverse',
          alignItems: 'center',
        },
      }}
    >
      <div css={{ minWidth: 0, flexGrow: 1, maxWidth: '100%' }}>
        <BarChart
          tab={state.tab}
          from={state.from}
          to={state.to}
          onBarClick={({ to, from }) => {
            setTo(to);
            setFrom(from);
          }}
          submissionsWithMonthCount={submissionsWithMonthCount}
        />
        <div
          css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: 10,
            paddingRight: 5,
            '@media (max-width: 1065px)': {
              flexDirection: 'column',
            },
          }}
        >
          <DatePicker
            tab={state.tab}
            from={state.from}
            to={state.to}
            setTo={setTo}
            setFrom={setFrom}
          />
          <button
            css={{
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              color: 'white',
              fontSize: 14,
              minWidth: 75,
              marginLeft: 10,
              marginRight: 10,
              textDecoration: 'underline',
              [smallMobileMQ]: {
                marginTop: 10,
              },
            }}
            onClick={() => setShowTable(true)}
          >
            View as table
          </button>
        </div>
      </div>
      <Aggregations aggregations={aggregations} />
    </div>
  );
}
